/* ══════════════════════════════════════════════════════════════
   Currency Panel — USD/INR, EUR/INR with Trend
   ══════════════════════════════════════════════════════════════ */

import { fetchCurrency } from '../services/market-data';
import { renderUnavailableBlock } from './data-state';

export interface CurrencyPairData {
  pair: string;
  rate: number;
  change: number;
  changePct: number;
  high: number;
  low: number;
  sparkline: number[];
}

function renderWithData(container: HTMLElement, data: CurrencyPairData[]): void {
  const cards = data.map(p => {
    const isUp = p.change >= 0;
    const color = isUp ? 'var(--india-green)' : 'var(--india-red)';
    return `
      <div class="currency-card glass-card">
        <div class="curr-header">
          <span class="curr-pair">${p.pair}</span>
          <span class="curr-rate">${p.rate.toFixed(p.rate < 1 ? 3 : 2)}</span>
        </div>
        <span class="curr-change" style="color:${color}">${isUp ? '▲' : '▼'} ${Math.abs(p.change).toFixed(p.rate < 1 ? 3 : 2)} (${p.changePct >= 0 ? '+' : ''}${p.changePct.toFixed(2)}%)</span>
        <div class="curr-range">
          <small>H: ${p.high.toFixed(2)} L: ${p.low.toFixed(2)}</small>
        </div>
      </div>`;
  }).join('');

  container.innerHTML = `
    <div class="currency-panel"><div class="card-header"><h3>💱 Currency</h3></div><div class="currency-grid">${cards}</div></div>`;
}

export function renderCurrencyPanel(container: HTMLElement, pairs?: CurrencyPairData[]): void {
  if (pairs) {
    renderWithData(container, pairs);
  } else {
    container.innerHTML = renderUnavailableBlock('currency-panel', 'Loading currency rates...');
    fetchCurrency().then(apiData => {
      if (apiData && apiData.length > 0) {
        const mapped: CurrencyPairData[] = apiData.map(c => ({
          pair: c.pair || c.name || '',
          rate: c.rate || 0,
          change: c.change || 0,
          changePct: c.pChange || 0,
          high: c.high || c.rate || 0,
          low: c.low || c.rate || 0,
          sparkline: [],
        }));
        renderWithData(container, mapped);
      } else {
        container.innerHTML = renderUnavailableBlock('currency-panel', 'Live currency feed unavailable');
      }
    }).catch(() => {
      container.innerHTML = renderUnavailableBlock('currency-panel', 'Live currency feed unavailable');
    });
  }
}
